
import {  polopolyIdHandler, createSrcSet } from '../polopoly-image/'
import {
  widths as supportedWidths,
  createImageUrl
} from '@nrk/serum-imagecrop-utils'

import styles from '../../../shared/index.css'

export const fullscreenVideoHandler = {
  property: 'data-fullscreen-video-element',
  load: (card) => {
    const elem = document.createElement('div')
    const id = card.getAttribute('data-background-id')
    elem.id = id

    const polopolyId = card.getAttribute('data-background-polopoly-id')

    const defaultUrl = createImageUrl({id: polopolyId, width: 1600, ratio: '1:1'})
    const desktopSourceSet = createSrcSet(polopolyId, '1:1', supportedWidths)
    const mobileSourceSet = createSrcSet(polopolyId, '3:4', supportedWidths)
    const backgroundImage = `
      <picture class="${styles['blurred']}" style="object-fit: cover;">
      <source media="(min-aspect-ratio: 3/4)" srcset="${desktopSourceSet}">
      <img src="${defaultUrl}" srcset="${mobileSourceSet}" style="min-width: 100%; min-height: 100%; position: relative; left: 50%; transform: translate3d(-50%, -50%, 0); top: 50%;">
      </picture>
      <div class="${styles['overlay']} ${styles['darkedout']}"></div>
    `

    // const backgroundImage = card.getAttribute('data-background-image')
    // elem.setAttribute('style', `background-image: url(${backgroundImage}); background-size: cover; background-position-x: center;`)
    elem.innerHTML = backgroundImage
    return elem
  }
}


// WEBPACK FOOTER //
// ./src/client/sections/fullscreen-video/index.js